<script>
   /*************************************************************/
   /* ResultsTable                                              */
   /* -------------------------                                 */
   /* shows table with PLS1-DA result objects.                  */
   /*************************************************************/

   import { untrack } from 'svelte';
   import { Container, Select } from 'svelte-controls-basic';

   let { res, model } = $props();

   const statsm = ['TN', 'FP', 'TP', 'FN'];
   const statsv = ['Sensitivity', 'Specificity', 'Efficiency', 'Accuracy'];
   const resIDs = $derived(Object.keys(res));

   // untrack marks the capture-at-mount as deliberate: the selection is seeded from the first
   // result and then owned by the user, so it must not re-sync when resIDs is recomputed
   let resID = $state(untrack(() => resIDs[0]));

   let out = $derived.by(() => {

      if (!res) return null;
      const r = res[resID];
      const header = model.rule === 'soft' ? ['', ...model.classNames, 'total'] : ['', ...model.classNames];
      let   rows = [];

      // TN, FP, TP, FN
      for (let stat of statsm) {
         let row = [stat];
         let acc = 0;
         for (let c of model.classNames) {
            const v = r.v[c].res[model.ncomp - 1][stat];
            acc += v;
            row.push(v);
         }
         if (model.rule === 'soft') {
            row.push(acc);
         }
         rows.push(row);

      }

      // FoMs
      for (let stat of statsv) {
         let row = [stat];
         const statl = stat.toLowerCase()
         for (let c of r.classNames) {
            const v = r.v[c].stat[statl][model.ncomp - 1];
            row.push(v.toFixed(3));
         }
         if (model.rule === 'soft') {
            const v = r.v['total'].stat[statl][model.ncomp - 1];
            row.push(v.toFixed(3));
         }
         rows.push(row);
      }


      return {header, rows};
   });
</script>


{#if out}
<table>
   <thead>
   <tr>
      {#each out.header as v}
      <th>{v}</th>
      {/each}
   </tr>
   </thead>
   <tbody>
   {#each out.rows as row (row[0])}
   <tr>
      {#each row as v}
      <td>{v}</td>
      {/each}
   </tr>
   {/each}
   </tbody>
   </table>

   {#if resIDs.length > 1}
   <!-- the container carries no label on purpose, the switcher sits under the table and is read
        from it. so the name is given here, or the control would have none at all -->
   <Container name="res-switcher">
      <Select options={resIDs} bind:value={resID} ariaLabel="Result set" />
   </Container>
   {/if}
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   td:first-of-type {
      width: 25%;
   }

   /* the class is repeated to outweigh svelte-controls-basic's own .control-element.<hash>
      rules, (0,2,0) and (0,3,0) with :hover, :first-child or :last-child. a tie leaves the winner
      to CSS order, which can differ between dev and build. sizes, gaps and corners keep the look
      of the radio labels this replaced */
   :global(.control-element.res-switcher.res-switcher.res-switcher) {
      margin: 0.66em 0 0 0;
      padding: 0;
      justify-content: center;
      background: transparent;
      font-size: 1em;
   }

   :global(.control-element.res-switcher.res-switcher.res-switcher:hover) {
      background: transparent;
   }

   :global(.control-element.res-switcher .selector) {
      justify-content: center;
   }

   :global(.control-element.res-switcher.res-switcher > .selector > .option) {
      font-size: 1em;
      margin: 0;
      border-radius: 0.25em;
      cursor: pointer;
      background-color: #e8e8e8;
      border-color: #708090;
      color: #607080;
   }

   :global(.control-element.res-switcher.res-switcher > .selector > .option + .option) {
      margin-left: 0.38em;
   }

   :global(.control-element.res-switcher.res-switcher > .selector > .option:not(.selected):hover) {
      background-color: #fffef0;
      color: #607080;
      border-color: #607080;
   }

   :global(.control-element.res-switcher.res-switcher > .selector > .option.selected) {
      background-color: #607080;
      color: #e8f0f8;
      border-color: #607080;
   }

</style>